var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.364,
    height: 21.364,
    viewBox: "0 0 21.364 21.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4117",
    "data-name": "Path 4117",
    d: "M21.075,2H4.289A2.292,2.292,0,0,0,2,4.289v6.867a2.292,2.292,0,0,0,2.289,2.289H6.578V22.6a.763.763,0,0,0,.972.734l5.132-1.466,5.132,1.466a.763.763,0,0,0,.972-.734V13.445h2.289a2.292,2.292,0,0,0,2.289-2.289V4.289A2.292,2.292,0,0,0,21.075,2ZM17.26,21.59l-4.369-1.248a.759.759,0,0,0-.419,0L8.1,21.59V8.867H17.26Zm4.578-10.434a.764.764,0,0,1-.763.763H18.786V8.867h.763a.763.763,0,1,0,0-1.526H5.815a.763.763,0,1,0,0,1.526h.763v3.052H4.289a.764.764,0,0,1-.763-.763V4.289a.764.764,0,0,1,.763-.763H21.075a.764.764,0,0,1,.763.763Z",
    fill: "#758ca1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4118",
    "data-name": "Path 4118",
    d: "M12.763,14.526h2.289a.763.763,0,0,0,0-1.526H12.763a.763.763,0,1,0,0,1.526Z",
    transform: "translate(-2.37 -2.607)",
    fill: "#758ca1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4119",
    "data-name": "Path 4119",
    d: "M12.763,22.526h2.289a.763.763,0,0,0,0-1.526H12.763a.763.763,0,1,0,0,1.526Z",
    transform: "translate(-2.37 -4.503)",
    fill: "#758ca1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4120",
    "data-name": "Path 4120",
    d: "M12.763,18.526h4.578a.763.763,0,0,0,0-1.526H12.763a.763.763,0,1,0,0,1.526Z",
    transform: "translate(-2.37 -3.555)",
    fill: "#758ca1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.d576242f.svg";
export { ForwardRef as ReactComponent };